/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary_actions_embed19 = /** @type {(inputs: {}) => string} */ () => {
	return `Copy link`
};

const fr_summary_actions_embed19 = /** @type {(inputs: {}) => string} */ () => {
	return `Copier le lien`
};

const de_summary_actions_embed19 = /** @type {(inputs: {}) => string} */ () => {
	return `Einbetten`
};

const es_summary_actions_embed19 = /** @type {(inputs: {}) => string} */ () => {
	return `Insertar`
};

const it_summary_actions_embed19 = /** @type {(inputs: {}) => string} */ () => {
	return `Incorporare`
};

const ar_summary_actions_embed19 = /** @type {(inputs: {}) => string} */ () => {
	return `تضمين`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const summary_actions_embed19 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary_actions_embed19(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary_actions_embed19", locale)
	if (locale === "en") return en_summary_actions_embed19(inputs)
	if (locale === "fr") return fr_summary_actions_embed19(inputs)
	if (locale === "de") return de_summary_actions_embed19(inputs)
	if (locale === "es") return es_summary_actions_embed19(inputs)
	if (locale === "it") return it_summary_actions_embed19(inputs)
	return ar_summary_actions_embed19(inputs)
};
export { summary_actions_embed19 as "SUMMARY_ACTIONS_EMBED" }